import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import cx from "classnames"
import { mq, fontSize } from "../mixins"
import "./staggeredImageText.scss"

const StaggeredImageText = props => {
  const staggeredImageTextContainer = css`
    ${mq("tablet")} {
      margin: 8.5% 0;
    }
  `

  const staggeredImageTextContent = css`
    padding: 0 17px;
    h3 {
      font-family: "Saira Condensed", sans-serif;
      font-weight: 700;
      text-transform: uppercase;
      margin: 32px 0 12px 0;
      line-height: 1.3;
      ${fontSize(28, 32)}
    }
    .staggeredImageText__content--border {
      width: 65px;
      height: 4px;
      background-color: rgba(97, 181, 16, 1);
    }
    ${mq("tablet")} {
      padding: 0;
      margin-left: 5.5%;
      h3 {
        margin-top: 0;
      }
    }
  `
  const staggeredImageTextContentDescription = css`
    padding: 0 0 48px 0;
    p {
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      color: rgba(97, 97, 97, 1);
      line-height: 1.75;
      margin-top: 16px;
    }
    ${mq("tablet")} {
      padding: 0;
    }
  `

  const StaggeredImageTextImg = styled("div")`
    position: relative;
    width: 100%;
    height: 375px;

    iframe {
      z-index: 2;
      width: 155px;
      height: 330px;
      border: 0;
      border-radius: 20px;

      ${mq("smTablet")} {
        width: 165px;
        height: 350px;
      }
      ${mq("tablet")} {
        width: 190px;
        height: 405px;
      }
    }

    &:after {
      content: "";
      top: 0;
      bottom: 0;
      position: absolute;
      background-position: top;
      background-size: cover;
      background-image: url(${props => props.bg});
      width: 100vw;
      right: 50%;
      left: 50%;
      margin-left: -50vw;
      margin-right: -50vw;
    }
    &.full_image:after {
      background-size: contain;
      background-repeat: no-repeat;
    }
  `

  const StaggeredImageTextBlock = styled("div")`
    ${props =>
      !!props.reverseOrder &&
      `&.staggeredImageText__block { flex-direction: row-reverse;}`}

    div.content_border_spacing {
      margin: 2rem 0 1rem;
    }

    &:before {
      content: "";
      width: 720px;
      height: 600px;
      top: 23%;
      left: -23%;
      bottom: 0;
      position: absolute;
      z-index: 1;
      background-position: center;
      background-size: cover;
      ${props =>
        props.flourish !== null &&
        `background-image: url(${props.flourish.url}) `}
    }
  `

  return (
    <div className="staggeredImageText">
      <div
        className="staggeredImageText__container"
        css={staggeredImageTextContainer}
      >
        {props.modular_blocks.map((item, key) => {
          return (
            <StaggeredImageTextBlock
              className={`staggeredImageText__block ${
                key % 2 === 0 ? "left-align" : "right-align"
              }
              ${
                item.staggered_image_text.top_align_flourish_image === true
                  ? "top-align-before"
                  : "bottom-align-before"
              }
              `}
              key={`${key}-leftRight`}
              flourish={item.staggered_image_text.flourish_image}
              reverseOrder={props.reverse_order}
            >
              <StaggeredImageTextImg
                bg={item.staggered_image_text.main_image.url}
                className={cx(`staggeredImageText__img`, {
                  full_image: !!item.staggered_image_text.full_image,
                })}
                key={`${key}-img`}
                role="img"
                aria-label={
                  (!!item.staggered_image_text.main_image &&
                    item.staggered_image_text.main_image.description) ||
                  (!!item.staggered_image_text.main_image &&
                    item.staggered_image_text.main_image.title)
                }
              >
                {!!item.staggered_image_text.embed_video &&
                  !!item.staggered_image_text.embed_video.href && (
                    <div className="staggeredImageText__img_video_wrapper">
                      <iframe
                        title={item.staggered_image_text.embed_video.title}
                        src={item.staggered_image_text.embed_video.href}
                        allowFullScreen="true"
                      ></iframe>
                    </div>
                  )}
              </StaggeredImageTextImg>
              <div
                className="staggeredImageText__content"
                css={staggeredImageTextContent}
              >
                <h3>{item.staggered_image_text.headline}</h3>
                <div
                  className={cx("staggeredImageText__content--border", {
                    content_border_spacing: !!item.staggered_image_text
                      .content_border_spacing,
                  })}
                ></div>
                <div
                  className="staggeredImageText__content__description"
                  css={staggeredImageTextContentDescription}
                  dangerouslySetInnerHTML={{
                    __html: item.staggered_image_text.rich_text_editor,
                  }}
                ></div>
              </div>
            </StaggeredImageTextBlock>
          )
        })}
      </div>
    </div>
  )
}

export default StaggeredImageText
